import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const HowItWorks = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-16">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
        <h1 className="text-5xl font-serif font-bold text-gray-900 dark:text-white mb-8 text-center">How Weaver Works</h1>
        <p className="text-xl text-gray-900 dark:text-purple-300 text-center mb-16">
          A seamless blend of your creativity and AI-powered worldbuilding.
        </p>

        <div className="space-y-12">
          <div className="flex flex-col md:flex-row gap-8 items-center bg-white dark:bg-purple-900/20 p-8 rounded-3xl border border-gray-100 dark:border-purple-800">
            <div className="p-6 bg-amber-100 dark:bg-amber-900/30 rounded-full text-amber-600">
              <SafeIcon icon={FiIcons.FiSettings} className="text-4xl" />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 dark:text-purple-50 mb-3">1. Set the Stage</h3>
              <p className="text-gray-900 dark:text-purple-300">
                Begin with an onboarding quiz and configure your world's genre, setting, and point of view. Create your protagonist with distinct traits and a backstory.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-8 items-center bg-white dark:bg-purple-900/20 p-8 rounded-3xl border border-gray-100 dark:border-purple-800">
            <div className="p-6 bg-gray-100 dark:bg-purple-900/40 rounded-full text-gray-900">
              <SafeIcon icon={FiIcons.FiFeather} className="text-4xl" />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 dark:text-purple-50 mb-3">2. The AI Game Master</h3>
              <p className="text-gray-900 dark:text-purple-300">
                The AI takes the role of the Game Master. It will present scenarios, control NPCs, and describe the consequences of your actions. It will never assume your character's feelings or force dialogue on your behalf.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-8 items-center bg-white dark:bg-purple-900/20 p-8 rounded-3xl border border-gray-100 dark:border-purple-800">
            <div className="p-6 bg-pink-100 dark:bg-pink-900/30 rounded-full text-pink-600">
              <SafeIcon icon={FiIcons.FiImage} className="text-4xl" />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 dark:text-purple-50 mb-3">3. Visualize and Archive</h3>
              <p className="text-gray-900 dark:text-purple-300">
                Generate images based on the current scene and your character's avatar. Track quests, summarize chapters, and export your entire narrative archive at any time.
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default HowItWorks;
